module.exports = __webpack_public_path__ + "img/norway-colorectal-cancer-male.1cc174cf.png";